<script lang="ts">
  import { i18n } from "../i18n.svelte";
  import { smoothScroll } from "../actions";
  import Logo from "./Logo.svelte";

  const f = $derived(i18n.t.footer);
  const nav = $derived(i18n.t.nav);
</script>

<footer class="footer">
  <div class="container">
    <div class="top">
      <div class="brand">
        <a href="#top" class="logo" use:smoothScroll aria-label="Tane home">
          <Logo size={34} />
          <span class="word">Tane</span>
        </a>
        <p class="tagline">{f.tagline}</p>
        <span class="chip"><span class="dot"></span>{f.status}</span>
      </div>

      <nav class="links" aria-label="Footer">
        <a href="#how" use:smoothScroll>{nav.how}</a>
        <a href="#features" use:smoothScroll>{nav.features}</a>
        <a href="#demo" use:smoothScroll>{nav.demo}</a>
        <a href="#pricing" use:smoothScroll>{nav.pricing}</a>
        <a href="#faq" use:smoothScroll>{nav.faq}</a>
      </nav>
    </div>

    <div class="bottom">
      <span>{f.location}</span>
      <span>{f.rights}</span>
    </div>
  </div>
</footer>

<style>
  .footer {
    border-top: 1px solid var(--line);
    background: var(--ink);
    color: rgba(245, 241, 231, 0.7);
    padding-block: clamp(2.5rem, 2rem + 2vw, 3.5rem);
  }
  .top {
    display: flex;
    justify-content: space-between;
    gap: 2rem;
    flex-wrap: wrap;
  }
  .logo {
    display: inline-flex;
    align-items: center;
    gap: 0.55em;
  }
  .word {
    font-family: var(--font-display);
    font-weight: 600;
    font-size: 1.4rem;
    color: var(--paper);
  }
  .tagline {
    margin-top: 1rem;
    max-width: 34ch;
    color: rgba(245, 241, 231, 0.7);
    font-size: 0.95rem;
  }
  .chip {
    display: inline-flex;
    align-items: center;
    gap: 0.5em;
    margin-top: 1.1rem;
    font-family: var(--font-mono);
    font-size: 0.7rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--sprout-soft);
    border: 1px solid rgba(95, 179, 100, 0.3);
    border-radius: 999px;
    padding: 0.4em 0.85em;
  }
  .chip .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--sprout);
    animation: pulse 2.6s var(--ease) infinite;
  }

  .links {
    display: flex;
    flex-direction: column;
    gap: 0.7rem;
    align-items: flex-end;
  }
  .links a {
    font-size: 0.92rem;
    color: rgba(245, 241, 231, 0.7);
    transition: color 0.3s var(--ease);
  }
  .links a:hover {
    color: var(--paper);
  }

  .bottom {
    margin-top: clamp(2rem, 1.5rem + 2vw, 3rem);
    padding-top: 1.4rem;
    border-top: 1px solid rgba(245, 241, 231, 0.12);
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    flex-wrap: wrap;
    font-size: 0.8rem;
    color: rgba(245, 241, 231, 0.5);
  }

  @media (max-width: 600px) {
    .links {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      gap: 0.7rem 1.4rem;
    }
  }
</style>
